// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var OMap = /* #__PURE__ */ (function () {
    function OMap(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    OMap.create = function (value0) {
        return function (value1) {
            return new OMap(value0, value1);
        };
    };
    return OMap;
})();
var values = function (v) {
    return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(v.value1);
};
var union = function (dictOrd) {
    return function (v) {
        return function (v1) {
            var aKeys = Data_Map.keys(v.value0);
            var b$prime$prime = Data_Array.filter(function (v2) {
                return !Data_Set.member(dictOrd)(v2.value0)(aKeys);
            })(v1.value1);
            return new OMap(Data_Map_Internal.union(dictOrd)(v.value0)(v1.value0), Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.value1)(b$prime$prime));
        };
    };
};
var udecodeMap = function (dictDecode) {
    return function (dictDecode1) {
        return function (dictOrd) {
            return {
                unsafeDecode: function (f) {
                    var kvs = Unscramble.unsafeDecode(Unscramble.decodeArray1(Unscramble.decodeTuple(dictDecode1)(dictDecode)))(f);
                    return new OMap(Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(kvs), kvs);
                }
            };
        };
    };
};
var toMap = function (v) {
    return v.value0;
};
var toArray = function (v) {
    return v.value1;
};
var showOMap = function (dictShow) {
    return function (dictShow1) {
        return {
            show: function (v) {
                return Data_Show.show(Data_Show.showArray(Data_Tuple.showTuple(dictShow)(dictShow1)))(v.value1);
            }
        };
    };
};
var semigroupOMap = function (dictOrd) {
    return {
        append: union(dictOrd)
    };
};
var lookup = function (dictOrd) {
    return function (dictEq) {
        return function (needle) {
            return function (v) {
                return Data_Map_Internal.lookup(dictOrd)(needle)(v.value0);
            };
        };
    };
};
var keysSet = function (v) {
    return Data_Map.keys(v.value0);
};
var keys = function (v) {
    return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(v.value1);
};
var fromArray = function (dictOrd) {
    return function (map) {
        return new OMap(Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(map), map);
    };
};
var findIndex = function (dictEq) {
    return function (needle) {
        return function (v) {
            return Data_Array.findIndex(function (v1) {
                return Data_Eq.eq(dictEq)(v1.value0)(needle);
            })(v.value1);
        };
    };
};
var eqOMap = function (dictEq) {
    return function (dictEq1) {
        return {
            eq: function (v) {
                return function (v1) {
                    return Data_Eq.eq(Data_Eq.eqArray(Data_Tuple.eqTuple(dictEq)(dictEq1)))(v.value1)(v1.value1);
                };
            }
        };
    };
};
var encodeMap = function (dictEncode) {
    return {
        encode: function (v) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(dictEncode))(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                return new Data_Tuple_T2.T2(v1.value0, v1.value1);
            })(v.value1));
        }
    };
};
var empty = /* #__PURE__ */ (function () {
    return new OMap(Data_Map_Internal.empty, [  ]);
})();
var monoidOMap = function (dictOrd) {
    return {
        mempty: empty,
        Semigroup0: function () {
            return semigroupOMap(dictOrd);
        }
    };
};
var decodeMap = function (dictDecode) {
    return function (dictOrd) {
        return {
            decode: function (f) {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(dictDecode))(f))(function (v) {
                    var kvs$prime = Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                        return new Data_Tuple.Tuple(v1.value0, v1.value1);
                    })(v);
                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new OMap(Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(kvs$prime), kvs$prime));
                });
            }
        };
    };
};
export {
    lookup,
    toArray,
    toMap,
    fromArray,
    union,
    empty,
    keys,
    keysSet,
    values,
    findIndex,
    showOMap,
    eqOMap,
    semigroupOMap,
    monoidOMap,
    encodeMap,
    decodeMap,
    udecodeMap
};
//# sourceMappingURL=index.js.map
